export var Origin;
(function (Origin) {
    Origin["User"] = "User";
    Origin["System"] = "System";
})(Origin || (Origin = {}));
var DictionaryEntryType;
(function (DictionaryEntryType) {
    DictionaryEntryType["About"] = "About";
    DictionaryEntryType["Hint"] = "Hint";
    DictionaryEntryType["Other"] = "Other";
})(DictionaryEntryType || (DictionaryEntryType = {}));
var CRSType;
(function (CRSType) {
    CRSType["EPSG_5514"] = "EPSG_5514";
    CRSType["EPSG_3857"] = "EPSG_3857";
    CRSType["EPSG_4326"] = "EPSG_4326";
})(CRSType || (CRSType = {}));
export var MapServiceType;
(function (MapServiceType) {
    MapServiceType["FeatureArcGIS"] = "FeatureArcGIS";
    MapServiceType["GeoCode"] = "GeoCode";
    MapServiceType["ImageArcGISRest"] = "ImageArcGISRest";
    MapServiceType["ImageWMS"] = "ImageWMS";
    MapServiceType["TILE"] = "TILE";
    MapServiceType["TileArcGIS"] = "TileArcGIS";
    MapServiceType["TileArcGISRest"] = "TileArcGISRest";
    MapServiceType["Vector"] = "Vector";
    MapServiceType["VectorTile"] = "VectorTile";
    MapServiceType["WFS"] = "WFS";
    MapServiceType["WMTS"] = "WMTS";
})(MapServiceType || (MapServiceType = {}));
var FormatType;
(function (FormatType) {
    FormatType["topojson"] = "topojson";
    FormatType["jpeg"] = "jpeg";
    FormatType["png"] = "png";
    FormatType["geojson"] = "geojson";
})(FormatType || (FormatType = {}));
var OutlineType;
(function (OutlineType) {
    OutlineType["Hidden"] = "Hidden";
    OutlineType["Thin"] = "Thin";
    OutlineType["Thick"] = "Thick";
})(OutlineType || (OutlineType = {}));
//# sourceMappingURL=types.js.map